import { Component, PropTypes } from 'react';

let didKruxScriptLoad = false;

class Krux extends Component {
  static propTypes = {
    uid: PropTypes.string.isRequired
  };

  componentDidMount() {
    const { uid } = this.props;

    if (!didKruxScriptLoad) {
      const kruxScript = document.createElement('script');
      kruxScript.type = 'text/javascript';
      kruxScript.async = true;
      kruxScript.src = `https://cdn.krxd.net/controltag/${uid}.js`;
      document.body.appendChild(kruxScript);
      didKruxScriptLoad = true;
      window.addEventListener('load', () => {
        const krux = window['Krux'];
        if (krux) {
          krux.user = this._retrieveSegment('user');
          krux.segments = this._retrieveSegment('segs') ? this._retrieveSegment('segs').split(',') : [];
        }
      });
    }
  }

  _retrieveSegment(name){
    const key = 'kxfrankly_' + name;
    const localStorage = window.localStorage;

    if (localStorage) {
        return localStorage[key] || '';
    } else if (navigator.cookieEnabled) {
        const m = document.cookie.match(key + '=([^;]*)');
        return (m && unescape(m[1])) || '';
    } else {
        return '';
    }
  }

  render() {
    return null;
  }
}

export default Krux;



// WEBPACK FOOTER //
// ./app/components/analytics/Krux.js